import './Section5Component.css'
import { Accordion, AccordionSummary } from '@mui/material'
import preguntas_arr from './preguntasFrecuentes.json'
import preguntas from './images/preguntas.png'
import { Section5IconComponent } from './Section5IconComponent';
import { useState } from 'react';

const setDefaultQuestionStates = () => {
    return preguntas_arr.map(() => false);
}

export const Section5Component = () => {

    const [questionSummaryStates, setQuestionSumamaryStates] = useState(setDefaultQuestionStates());
 
    const changeSpecificQuestionState = (index) => {
        const newState = [...questionSummaryStates];
        newState[index] = !newState[index];
        setQuestionSumamaryStates(newState);
    }
    const getAccordionSummary = (index) => {
        const question = preguntas_arr[index].titulo;
        return (
            <AccordionSummary
                expandIcon={<Section5IconComponent isOpen={questionSummaryStates[index]} />}
                onClick={ev => changeSpecificQuestionState(index)}
            >
                <h6 className={'mb-0 rubik_bold '+(questionSummaryStates[index]? 'blue_cl':'white_cl')}>{question}</h6>
            </AccordionSummary>
        )
    }

    const getAccordionDetails = (index) => {
        const answer = preguntas_arr[index].respuesta;
        const paragraphs = answer.split('<br>');
        const paragraphsAmount = paragraphs.length;
        return (
            <div className='white_bg px-3 pb-3'>
                {
                    paragraphs.map(
                        (p,index) => {
                            return (
                                <>
                                    <p className="mb-0 rubik_regular answer">
                                        {p}
                                    </p>
                                    {
                                        (index<(paragraphsAmount-1) && paragraphsAmount>1) ?
                                        <br />
                                        :
                                        <>
                                        </>
                                    }                        
                                </>
                            )
                        }   
                    )
                }

            </div>
        )
    }
    return (
        <div className='py-5 px-2 px-lg-0 soft_gray_bg' id='preguntas'>
        <div className="container_2 d-flex flex-column flex-lg-row align-items-center justify-content-between 
            text-center text-lg-start mb-5">
            <h2 className='rubik_medium blue_cl mb-3 mb-lg-0'>Preguntas Frecuentes</h2>
            <div>
                <img src={preguntas} alt="Preguntas" className='img-fluid'/>
            </div>
        </div>

        <div className="container">

            <div className='d-flex flex-column gap-3 container-questions'>
                {preguntas_arr.map((p,index) => {
                    return (
                    <Accordion 
                    sx= {
                            {backgroundColor: 
                                (questionSummaryStates[index]?'#FFFFFF!important':'#00A3E1!important')
                            }
                        }
                    key={index}>
                        {getAccordionSummary(index)}
                        {getAccordionDetails(index)}
                    </Accordion>
                    )

                })}
            </div>

        </div>

        </div>

    )
}